import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Form, Row, Modal, Button, Image } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import {
  ORDER_TYPE_NAME,
  ITEMTYPEVEG,
  DELIVERY_TYPES,
  FLAT_CHARGE_KEYS,
} from "../../enums/OrderEnums";
import InfoToolTip from "./InfoTooltipComponent";
import { getFlatCharges } from "../../function/getFlatCharges";
import isEmpty from "../../store/validation/is-Empty";
import Alert from "react-s-alert";

import {
  calcDiscount,
  calcFinalTotal,
  calcTotalOriginal,
} from "../../function/ordering";
import { values } from "lodash";

const ExpCashModal = ({ experience, formik, hideModal }) => {
  const [userData, setUserData] = useState();
  const [cartData, setCartData] = useState();
  const [pendingAmount, setPendingAmount] = useState(false);
  const [offerData, setOfferData] = useState();
  const [summary, setSummary] = useState({});
  const subscriptionData = useSelector((state) => {
    return !isEmpty(state?.onboarding?.onboard_subscription_details)
      ? state?.onboarding?.onboard_subscription_details
      : "";
  });

  // useEffect(() => {
  //   setCartData(props?.cartData);
  //   setUserData(props?.userData);
  //   setOfferData(props?.offerData);
  //   let summary = calcFinalTotal(
  //     props?.cartData,
  //     props?.userData,
  //     props?.offerData,
  //     props?.subscriptionData
  //   );
  //   setSummary(summary);
  // }, [
  //   props?.cartData,
  //   props?.userData,
  //   props?.offerData,
  //   props?.subscriptionData,
  // ]);

  const [cash, setCash] = useState("");
  const [cashError, setCashError] = useState(false);
  const [remaining, setRemaining] = useState(0);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  const handleCash = (e) => {
    if (
      /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/.test(parseFloat(e.target.value))
    ) {
      setCash(e.target.value);
      setCashError(false);
      setPendingAmount(false);
      setRemaining((parseFloat(e.target.value) - formik.values.paymentData.totalAmount).toFixed(2));
    } else {
      setCashError(true);
      setPendingAmount(true);
      setCash("");
      setRemaining(0);
    }
  }


  const onClickDoneButton = () => {
    // Alert.error(`<h4>Please Pay Pending Amount</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    setPendingAmount(true);
  };

  return (
    <React.Fragment>
      <Modal
        show={true}
        centered
        size="md"
        backdrop="static"
      >
        <Modal.Header
          className="border-0 d-block"
          style={{ backgroundColor: "#fff2d5" }}
        >
          <div className="col-12 d-flex align-items-center mb-3">
            <h5 className="f11-400"> Experience ID:</h5>
            <p className="f11-500 mr-4 ml-1 text-red">
              {experience?.expId || "N/A"}
            </p>
          </div>
          <div className="col-12 f20-700 mb-1">
            {formik.values.userDetails.name || ""}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row
            className="f12-500 align-items-center px-3 pb-3"
            style={{ backgroundColor: "#ffffff" }}
          >
            <Col xs={12} sm={12} md={12}>
              <TextField
                label="Enter received amount"
                variant="outlined"
                type="number"
                className={`w-100  ${cashError ? "enError" : ""}`}
                onInput={maxLengthCheck}
                inputProps={{ maxLength: 10 }}
                name="reference"
                value={cash}
                onChange={handleCash}
              />
            </Col>
          </Row>
          <Row className="p-3">
            <Col xs={12} sm={12} md={12}>
              <Row className="pb-3">
                <Col className="text-left d-flex align-items-center">
                  <h5 className="f14-700">Ticket Details</h5>
                </Col>
              </Row>
            </Col>
            {
              formik.values.adultCount ? <Col xs={12} sm={12} md={12}>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f14-400">Adult Ticket :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f14-400">₹ {formik.values.adultCount * formik.values.adultPrice}</h5>
                  </Col>
                </Row>
              </Col> : <></>
            }
            {
              formik.values.kidsCount ? <Col xs={12} sm={12} md={12}>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f14-400">Kids Ticket :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f14-400">₹ {formik.values.kidsCount * formik.values.kidsPrice}</h5>
                  </Col>
                </Row>
              </Col> : <></>
            }
            {
              formik.values.package.count ? <Col xs={12} sm={12} md={12}>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f14-400">Package :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f14-400">₹ {formik.values.package.count * formik.values.package.price}</h5>
                  </Col>
                </Row>
              </Col> : <></>
            }
            {
              formik.values.paymentData.donationAmount ? <Col xs={12} sm={12} md={12}>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f14-400">Donation :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f14-400">₹ {formik.values.paymentData.donationAmount}</h5>
                  </Col>
                </Row>
              </Col> : <></>
            }
          </Row>
          <Row className="p-3">
            <Col xs={12} sm={12} md={12}>
              <Row className="pb-3">
                <Col className="text-left d-flex align-items-center">
                  <h5 className="f15-700">Total :</h5>
                </Col>
                <Col className="text-right">
                  <h5 className="f15-700">₹ {formik.values.paymentData.totalAmount}</h5>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="p-3">
            <Col xs={12} sm={12} md={12}>
              <Row className="pb-3">
                <Col className="text-left d-flex align-items-center">
                  <h5 className="f18-700">Amount Received :</h5>
                </Col>
                <Col className="text-right">
                  <h5 className="f18-700">₹ {cash !== "" ? cash : 0}</h5>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="py-3 px-3" style={{ backgroundColor: "#fff2d5" }}>
            <Col xs={12} sm={12} md={12}>
              <Row>
                <Col className="text-left">
                  <h5 className="f15-700">
                    {remaining < 0 ? "Amount Pending" : "Amount To Be Returned"}{" "}
                  </h5>
                </Col>
                <Col className="text-right">
                  <h5 className={`f18-700 ${remaining < 0 ? "text-red" : ""}`}>
                    ₹ {Math.abs(remaining)}
                  </h5>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="px-3 pt-3 justify-content-center">
            <div className="col-5">
              <Button
                variant="outline-secondary"
                className="btn-md py-2"
                style={{ width: "90%" }}
                onClick={() => hideModal(true)}
              >
                Cancel
              </Button>
            </div>
            <div className="col-5">
              <Button
                variant="danger"
                className="btn-md py-2 w-100"
                onClick={
                  parseInt(cash) < parseInt(formik.values.paymentData.totalAmount)
                    ? onClickDoneButton
                    : () => hideModal(parseInt(cash) < parseInt(formik.values.paymentData.totalAmount))
                }
                disabled={parseInt(cash) === 0 || cash === "" ? true : false}
              >
                Done
              </Button>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ExpCashModal;
